export function formatDate(value?: string) {
  if (!value) return '从未';
  return new Intl.DateTimeFormat('zh-CN', { dateStyle: 'medium', timeStyle: 'short' }).format(new Date(value));
}

export function formatPercent(value: number) {
  return `${Math.round(value * 100)}%`;
}

export function statusText(status: string) {
  return ({ active: '正常', disabled: '已停用', completed: '已完结', frozen: '已冻结', visible: '可见', hidden: '已隐藏' } as Record<string, string>)[status] ?? status;
}
